import React from 'react';
import { Container, Button} from 'react-bootstrap';
import ServiceProviderCard from './ServiceProviderCard';
import InvitationSection from './InvitationSection';
import FAQSection from './FAQSection';
import InfoCardsSection from './InfoCardsSection';
import CTASection from './CTASection';

const MainContent = ({state, onLogin}) => {
  return (
    <Container as="main" className="main-content">
      {/* Hero Section */}
      <section className="hero-section">
        <h1>Запишіть дитину до дитячого садочка</h1>
        <p className="lead">
          Портал дошкільної освіти міста Києва — це централізована платформа для батьків, 
          які шукають дитячий садок для своєї дитини. Тут ви можете знайти інформацію про 
          доступні заклади дошкільної освіти, подати заявку на зарахування та отримати 
          необхідні адміністративні послуги у сфері дошкільної освіти столиці.
        </p>
              {state === "authsuccess" ? <Button variant="primary" href="profile" size="lg" >Подати заявку</Button> : <Button variant="primary" onClick={onLogin} size="lg" >Подати заявку</Button>  }
        <p className="sub-text">Авторизуйтеся за допомогою Київ ID</p>
      </section>

      <ServiceProviderCard />
      <InvitationSection />
      <FAQSection />
      <InfoCardsSection />
      <CTASection state={state} onLogin={onLogin}/>
    </Container>
  );
};

export default MainContent;